
import Component from 'vue-class-component'
import { Mixins } from 'vue-property-decorator'
import { ScreenId } from '@/utilities'
import { StoreMixin } from '@/mixins'

@Component({
  components: {
    [ScreenId.MTP_0000]: () => import('@/views/MTP_0000.vue'),
    ExternalLowerLinks: () => import('@/views/MTP_0300.vue'),
    EdittingProfile: () => import('@/components/UpdateUserStepper.vue'),
    ApplyTicketProcess: () => import('@/components/ApplyTicketProcess.vue'),
    PurchaseOptionProcess: () => import('@/components/PurchaseOptionProcess.vue'),
    RouteTicketPurchaseProcess: () => import('@/components/RouteTicketPurchaseProcess.vue'),
    TicketManagementPurchaseOptionProcess: () => import('@/components/TicketManagementPurchaseOptionProcess.vue')
  }
})
export default class TopTab extends Mixins(StoreMixin) {
  constructor() {
    super()
  }
}
